import Cookies from 'js-cookie';
import HomeApiService from "@/services/api/HomeApiService";
import ViajesGrupoApiService from "@/services/api/ViajesGrupoApiService";

const COOKIE_VISITA_APP = 'visita_app';
const COOKIE_VISITA_VIAJE_PREFIX = 'visita_viaje_';
const DURACION_COOKIE_MINUTOS = 20;

/**
 * Calcula la fecha de expiración de la cookie en minutos
 * @returns {Date} Fecha de expiración
 */
function getCookieExpires() {
  return new Date(new Date().getTime() + DURACION_COOKIE_MINUTOS * 60 * 1000);
}

/**
 * Comprueba si ya existe una cookie de visita para el aplicativo.
 * Si no existe, la crea y devuelve true para indicar que se debe incrementar el contador.
 * Si ya existe, devuelve false para indicar que NO se debe incrementar el contador.
 *
 * @returns {boolean} true si se debe registrar la visita al aplicativo, false si ya fue registrada recientemente
 */
export function shouldRegisterAppVisit() {
  if (Cookies.get(COOKIE_VISITA_APP)) {
    return false;
  }
  Cookies.set(COOKIE_VISITA_APP, 'true', { expires: getCookieExpires() });
  return true;
}

/**
 * Comprueba si ya existe una cookie de visita para un viaje concreto.
 * Si no existe, la crea y devuelve true para indicar que se debe incrementar el contador.
 * Si ya existe, devuelve false para indicar que NO se debe incrementar el contador.
 *
 * @param {number|string} viajeId - Identificador del viaje
 * @returns {boolean} true si se debe registrar la visita al viaje, false si ya fue registrada recientemente
 */
export function shouldRegisterViajeVisit(viajeId) {
  const cookieKey = `${COOKIE_VISITA_VIAJE_PREFIX}${viajeId}`;
  if (Cookies.get(cookieKey)) {
    return false;
  }
  Cookies.set(cookieKey, 'true', { expires: getCookieExpires() });
  return true;
}

export async function registerAppVisit() {
  if (shouldRegisterAppVisit()) {
    await HomeApiService.incrementaVisitasAgencia();
  }
}

export async function registerViajeVisit(viajeId, codigoViaje, codigoPrevisualizacion) {
  if (shouldRegisterViajeVisit(viajeId)) {
    await ViajesGrupoApiService.incrementaVisitasViaje(viajeId, codigoViaje, codigoPrevisualizacion);
  }
}
